import { Box, SxProps, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";

interface TelegramSectionProps {
  title?: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
}

export function TelegramSection({
  title,
  children,
  sx,
  containerSx,
}: TelegramSectionProps) {
  return (
    <Box sx={{ mb: 2.2, ...containerSx }}>
      {title && (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            textTransform: "uppercase",
            fontSize: "0.72rem",
            fontWeight: 700,
            color: "text.secondary",
            letterSpacing: "0.05em",
            px: 2,
            mb: 0.8,
          }}
        >
          {title}
        </Typography>
      )}
      <Box
        sx={{
          bgcolor: "background.paper",
          borderRadius: "12px",
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0 4px 16px -2px rgba(0, 0, 0, 0.25)"
              : "0 2px 12px -2px rgba(196, 140, 58, 0.06)",
          ...sx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default TelegramSection;
